import React, { useMemo } from 'react';
import moment from 'moment';
import { useTranslation } from 'react-i18next';

import './index.scss';
import { formatDateTimePreOrder, getHumanizeTimeDuration } from '../../../../utils/order';
import { Avatar } from '../../Avatar/Avatar';
import { PICKUP_STATE } from '../../../../utils/enums';
import { getDepotByIdMap } from '../../../../services/restaurant';
import IconButton from '../../IconButton';
import { Button, Dropdown } from 'antd';
import classNames from 'classnames';
import { isRTL } from '../../../../services/userModel';

export const addFiled = (string, filed, prefix = '') => {
    if (string && filed) {
        return `${string} , ${prefix}${filed}`;
    }
    if (!string && filed) {
        return `${prefix}${filed}`;
    }

    return string;
};

export const PickupOrderDraftItem = ({
    depotId,
    state,
    estimatedTimeToArrival,
    timeOfArrival,
    extendedState,
    children,
    onClickDelete,
}) => {
    const { t } = useTranslation();

    const depot = getDepotByIdMap(depotId);

    const validAddress = useMemo(
        () =>
            addFiled(
                depot?.address?.address?.street,
                depot?.address?.address?.city
            ),
        [depot]
    );

    const arrivedData = useMemo(() => {
        switch (state) {
            case PICKUP_STATE.pending:
                return {
                    title: t('draft.arrivingIn'),
                    time:
                        estimatedTimeToArrival === null
                            ? null
                            : estimatedTimeToArrival
                                ? getHumanizeTimeDuration(
                                    moment(),
                                    moment(estimatedTimeToArrival)
                                )
                                : ''
                };

            default:
                return {
                    title: t('draft.arrived'),
                    time:
                        timeOfArrival === null
                            ? null
                            : timeOfArrival
                                ? formatDateTimePreOrder(timeOfArrival)
                                : ''
                };
        }
    }, [estimatedTimeToArrival, state, timeOfArrival, t]);

    const handleMenuClick = (e) => {
        onClickDelete();
    };

    const menuProps = {
        items: [{
            label: t('draft.delete'),
            key: 'disband',
            icon: <IconButton iconName={'trash-can'} isIcon/>
        }],
        className: classNames("draftMenuItem", {rtl: isRTL()}),
        onClick: handleMenuClick,
    };

    return (
        <div className="pickup-card-draft">

            <div className='pickup-card-draft-body'>
                <div className="pickup-card-draft__container">

                    <div className="pickup-card-draft__logo">

                        {depot?.logoUrl && (
                            <Avatar avatar={depot.logoUrl} />
                        )}

                        <div className="pickup-card-draft__info">

                            <div className="pickup-card-draft__name">
                                {depot?.name}
                            </div>

                            <div className="pickup-card-draft__address">
                                {validAddress}
                            </div>

                            {extendedState === 0 ? (
                                <div className="pickup-card-draft__pickup-progress">
                                    {t('order.extendedStatus.pickupInProgress')}
                                </div>
                            ) : (
                                <div className="pickup-card-draft__row">
                                    <span className="pickup-card-draft__label">
                                        {arrivedData.time ? arrivedData.title : ''}&nbsp;
                                    </span>

                                    <span className="pickup-card-draft__address">
                                        {arrivedData.time ? arrivedData.time : ''}
                                    </span>
                                </div>
                            )}

                        </div>
                    </div>

                    {state === PICKUP_STATE.arrived && (
                        <div className="pickup-card-draft__status">
                            <span className="pickup-card-draft__status-text">
                                {t('draft.done')}
                            </span>
                            <IconButton isIcon iconName={'checkIcon'} />
                        </div>
                    )}

                </div>

                {children}
            </div>

            <div className="contextMenuDort" draggable={false} onPointerDown={(e) => e.stopPropagation()}>
                <Dropdown menu={menuProps} placement="bottomRight">
                    <Button icon={<IconButton isIcon iconName={'menu-dots'} />} />
                </Dropdown>
            </div>

        </div>
    );
};
